import { useDispatch, useSelector } from 'react-redux';
import { login, logout, reCaptchaVarify } from 'store/auth';
import { teardownPushOnLogout } from 'api/Auth';
import { preserveDeviceId } from 'lib/push';

function useAuthStore() {
  const isLoggedIn = useSelector((state) => state.auth.isAuth);
  const user = useSelector((state) => state.auth.data);
  const AccessToken = useSelector((state) => state.auth?.tokens?.access);
  const Loginshow = useSelector((state) => state.auth?.show);
  const dispatch = useDispatch();
  const loginAction = (params) => dispatch(login(params));
  // Deactivate this browser's platform device row BEFORE the session goes —
  // the endpoint is session-authenticated, so afterwards the row can never be
  // cleaned up and the backend keeps pushing platform alerts (which name
  // tenants and failures) to a browser nobody is signed into. Time-boxed
  // internally and never throws, so it cannot hang or block the sign-out.
  //
  // The push device_id identifies the BROWSER, not the user, so it has to
  // outlive any storage wipe: dropping it makes the next login register a
  // second row for the same browser and every later send fan out twice.
  const logoutAction = async () => {
    await teardownPushOnLogout();
    return preserveDeviceId(() => dispatch(logout()));
  };
  const reCaptchaVarifyAction = (params) => dispatch(reCaptchaVarify(params));
  return {
    // state of Analytics
    isLoggedIn,
    user,
    AccessToken,
    Loginshow,
    // action of Analytics
    loginAction,
    logoutAction,
    reCaptchaVarifyAction
  };
}
export default useAuthStore;
